import { makeStyles } from '@material-ui/core/styles';

export const useResetEmailStyles = makeStyles(theme => ({
    bodyContainer: {
        minHeight: '45px',
        // paddingTop: "56px",
        paddingBottom: '12px',
        position: 'relative',

        '@media(max-width: 599px)': {
            minHeight: '203px',
            // paddingTop: "65px",
            paddingBottom: '24px',
            paddingLeft: '16px',
            paddingRight: '16px',
        },

        '& .register-email-body': {
            maxWidth: '376px',
            margin: '0px auto',

            '& input[type=number]::-webkit-inner-spin-button,& input[type=number]::-webkit-outer-spin-button': {
                WebkitAppearance: 'none',
                margin: '0',
            },
            '& input[type=number]': {
                MozAppearance: 'textfield',
            },
        },

        '& .register-grid-text-content': {
            // fontFamily: "gt-walsheim-regular",
            // fontStyle: "normal",
            // fontWeight: 400,
            // fontSize: "14px",
            // lineHeight: "22px",
            // color: "rgba(50, 52, 53, 0.87)",
            color: theme.palette.primary.heather,

            textAlign: 'left',
        },

        ' & .register-email-grid-email, & .register-email-grid-confirm-email': {
            marginBottom: '20px',
            '@media(max-width: 599px)': {
                marginBottom: '27px',
            },

            ' & .register-grid-input-text-field': {
                width: '100%',

                fontFamily: theme.typography.body2.fontFamily,
                fontStyle: 'normal',
                fontWeight: 400,
                '& .email-code': {
                    width: '376px',
                    color: theme.palette.primary.heather,
                    borderColor: theme.palette.primary.heather,
                    [theme.breakpoints.down('xs')]: {
                        width: '248px',
                    },
                },

                ' & .text-field-input-label-props-root': {
                    color: theme.palette.primary.heather80,
                    fontFamily: theme.typography.body2.fontFamily,
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: theme.typography.body1.fontSize,
                    lineHeight: '19px',
                    letterSpacing: '0.15px',
                    marginTop: '6px',
                },
                '& .text-field-input-label-props-focused': {
                    color: theme.palette.primary.heather,
                    // fontSize: "12px",
                    lineHeight: '16px',
                    marginTop: '0px !important',
                },
                '& .text-field-input-label-props-shrink': {
                    //    color:'lightgrey',
                    marginTop: '0px !important',
                },
                '& .text-field-input-label-props-focused-invalid, & .text-field-input-label-props-shrink-invalid': {
                    color: theme.palette.primary.error,
                    marginTop: '0px !important',
                },
                '& .text-field-input-label-props-shrink-nonMatch': {
                    color: theme.palette.primary.error,
                    marginTop: '0px !important',
                },
                '& .new-password-root': {
                    color: theme.palette.primary.heather,
                    fontFamily: theme.typography.body2.fontFamily,
                    fontStyle: 'normal',
                    fontWeight: 400,
                    fontSize: theme.typography.body1.fontSize,
                    lineHeight: '19px',
                    letterSpacing: '0.15px',

                    padding: '8px',
                    '&.new-password-input-focused': {
                        '& .new-password-input-notched': {
                            borderColor: theme.palette.primary.heather,
                        },
                    },
                    '&:hover': {
                        '& .new-password-input-notched': {
                            borderColor: theme.palette.primary.heather,
                        },
                    },
                    '&.new-password-error': {
                        '& .new-password-input-notched': {
                            borderColor: `${theme.palette.primary.error} !important`,
                        },
                    },
                    '& .new-password-input-notched': {
                        borderColor: theme.palette.primary.heather,
                    },
                },
            },

            '& .invalid-email-format': {
                fontFamily: theme.typography.inputLabel.fontFamily,
                // fontStyle: 'normal',
                // fontWeight: 400,
                // fontSize:theme.typography.inputLabel.fontSize,
                // lineHeight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                letterSpacing: '0.4px',
                color: theme.palette.primary.error,

                marginTop: '3px',
            },
        },
    },
    emailText: {
        marginTop: '42px',
        marginBottom: '24px',
        maxWidth: '376px',
        maxHeight: '44px',
        textAlign: 'left',
        fontFamily: theme.typography.body2.fontFamily,
        fontWeight: 'normal',
        fontSize: theme.typography.subtitle2.fontSize,
        lineHeight: '157%',
        color: theme.palette.primary.heather,
        margin: '0 auto',
        paddingLeft: '6px',
        [theme.breakpoints.down('xs')]: {
            marginTop: '24px',
            maxWidth: '248px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    emailApiError: {
        fontFamily: theme.typography.body2.fontFamily,
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: theme.typography.inputLabel.fontSize,
        lineHeight: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        letterSpacing: '0.4px',
        color: theme.palette.primary.error,

        marginTop: '3px',
    },
}));
